import { useAuth } from '../../../../utils/Auth';
import { useOrganization } from '../../../../utils/OrganizationContext';
import { useNavigate } from 'react-router-dom';
import WidgetCollection from '../../../WidgetComponents/WidgetCollection';
import styles from './Widgets.module.css';

const Widgets = () => {
  const { qr_data } = useAuth();
  const { activeOrganization } = useOrganization();
  const navigate = useNavigate();
  const qrId = qr_data?.id;
  const hasWidgetAccess = activeOrganization?.plan?.widgets > 0;

  if (!hasWidgetAccess) {
    return (
      <div className={styles.container}>
        <div className={styles.upgradeMessage}>
          <p>Upgrade your plan to create and manage widgets.</p>
          <button className={styles.upgradeBtn} onClick={() => navigate('/organizations/settings')}>
            Upgrade
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <h5 className={styles.header}>Widgets</h5>
        <button className={styles.embeddedCreateBtn} onClick={() => navigate('/widgets', { state: { qrId }})}>
          <i className='far fa-plus' /> Create Widget
        </button>
      </div>
      <div className={styles.collectionRow}>
        <WidgetCollection qrIdFilter={qrId} />
      </div>
    </div>
  );
};

export default Widgets;
